/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	CustomerValidateBillingDetailsPathParams,
	CustomerValidateBillingDetailsQueryParams,
	CustomerValidateBillingDetailsResponse,
} from '../types/CustomerValidateBillingDetails'

/**
 * GET /:organisation/customer/validate-billing
 * @see backend/nexus/modules/Billing/Http/Controllers/CustomerController.php CustomerController::validateBillingDetails
 */
export async function customerValidateBillingDetails(
	organisation: CustomerValidateBillingDetailsPathParams['organisation'],
	params?: CustomerValidateBillingDetailsQueryParams,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CustomerValidateBillingDetailsResponse>> {
	return axiosInstance.get(`/${organisation}/customer/validate-billing`, { params, ...config })
}
